import { useState } from 'react'

/** Character portrait: the submitted image, or a "WIP" placeholder when none
 *  was provided (or the link is dead). Shared by gallery cards and detail. */
export function CharacterImage({ src, alt }: { src: string | null; alt: string }) {
  const [failed, setFailed] = useState(false)
  const showImage = src && !failed

  return (
    <div className="relative aspect-[3/4] w-full overflow-hidden border-b border-edge bg-void-2">
      {showImage ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          referrerPolicy="no-referrer"
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2">
          <div className="h-2 w-2 animate-pulse rounded-full bg-signal/40" />
          <span className="font-display text-xs uppercase tracking-[0.45em] text-slate-600">
            wip
          </span>
          <span className="text-[10px] text-slate-700">
            {src ? 'image link unreachable' : 'no image linked yet'}
          </span>
        </div>
      )}
    </div>
  )
}
